import $ from 'jquery';
import slick from 'slick-carousel';
import config from '../app-config';

function setTabs() {
    const tabs = $('.tabs');

    tabs.slick({
        dots: false,
        arrows: false,
        variableWidth: true,
        infinite: false,
        edgeFriction: 0,
        swipeToSlide: true
    });
    
}

function startTabs() {
    const trigger = $('.js-tab-trigger');
    const target = $(this);
    const classToToggle = 'is-active';
    const targetHasClass = target.hasClass(classToToggle);

    $('.js-tab').css('display', 'none');
    $('.js-tab-1').css('display', 'flex');

    trigger.on('click', function (event) {

        event.preventDefault();

        trigger.removeClass(classToToggle);
        $(this).addClass(classToToggle);

        let popupId = parseInt($(this).attr('id').substr(-1));
        let targetPopup = $('.js-tab-' + parseInt(popupId));

        $('.js-tab').css('display', 'none');
        targetPopup.css('display', 'flex');
        
    });
}

function slideDown() {
    $('.js-slide-down').each(function() {

        const slideTrigger = $(this).children('.esti-settings__button');
        const sliderForm = $(this).children('.esti-settings__form');
        const height = $(this).children('.esti-settings__form').height();
        const active = 'is-active';

        if ($(this).hasClass(active)) {

        } else {
            $(this).children('.esti-settings__form').css('height', 0);
        }

        slideTrigger.on('click', function() {

            if ($(this).parent().hasClass(active)) {
                $(this).parent().removeClass(active);
                sliderForm.css('height', 0);
            } else {
                $(this).parent().addClass(active);
                sliderForm.css('height', height);
            }

        })

    })
}

function init() {
    if ($(window).width() < config.breakpoints.medium && $('.tabs').length > 0) setTabs();
    if ($(window).width() < config.breakpoints.medium && $('.esti-settings').length > 0) slideDown();

    if ($('.tabs').length > 0) startTabs();

}

export { init };


// WEBPACK FOOTER //
// ./src/_app/layout/tabs.js